import BasePagedListSetup from '@/components/BasePagedListSetup';
import BaseSetup from '@/components/BaseSetup';
import { Reactive } from '@/utils/decorators';
import { highlightDomElement } from '@orion.ui/orion';
import { nextTick, ref } from 'vue';

type Actions = 'search' | 'checkAll' | 'filter';

export type SharedPagedListActionsEmits = {};

export type SharedPagedListActionsProps = {
	use?: Actions[]
	listService: BasePagedListSetup<RawEntity>
};

export default class SharedPagedListActionsSetup extends BaseSetup {

	static readonly defaultProps = { use: () => ['search', 'checkAll', 'filter'] as Actions[] };

	readonly _listSearchField = ref<OrionInput>();
	readonly _el = ref<HTMLElement>();

	@Reactive private readonly state = { displayListSearchField: false };

	get displayListSearchField () { return this.state.displayListSearchField }
	get listService () { return this.props.listService }
	get filterService () { return this.listService.filterService }

	get listFilterResearch () { return (this.filterService.filter as PagedListFilter).research }
	set listFilterResearch (val: string | undefined) {
		if (!this.filterService) return;
		(this.filterService.filter as PagedListFilter).research = val;
	}

	constructor (
		private props: SharedPagedListActionsProps,
		private emits: SharedPagedListActionsEmits,
	) {
		super();

		if ((this.filterService.filter as PagedListFilter).research?.length) {
			this.state.displayListSearchField = true;
		}

		this.registerBusEvent('breakpoint', (val: (
		  | 'onLayoutFull'
		  | 'onLayoutOneAside'
		  | 'onLayoutNoAside'
		  | 'onLayoutNavFull'
		  | 'onLayoutNavCollapsed'
		  | 'onLayoutNavBottom'
		)[]) => {
			setTimeout(() => {
				if (val.includes('onLayoutNoAside')) {
					highlightDomElement(this._el.value);
				}
			}, 500);
		});
	}

	async refreshListAsync (resetPagination = false) {
		await this.filterService?.applyWithRouterAsync(resetPagination);
		this.hideListSearchField();
	}

	showListSearchField () {
		this.state.displayListSearchField = true;
		nextTick(() => this._listSearchField.value?.focus());
	}

	hideListSearchField () {
		if (this.listFilterResearch?.length) return;
		this.state.displayListSearchField = false;
	}

}
